import { useTranslation } from 'react-i18next';

import {
    Button,
    Modal,
    ModalComponent,
    ModalProps,
} from '@speeki/global-ui-components';

import { AuthService } from '@services/AuthService/AuthService';

interface CompanyChangeModalProps
    extends Pick<ModalProps, 'onClose' | 'open'> {}

export const CompanyChangeModal = ({
    onClose,
    open,
}: CompanyChangeModalProps) => {
    const { t } = useTranslation();

    return (
        <ModalComponent closeButton onClose={onClose} open={open} width={648}>
            <Modal.Content variant="secondary">
                <Modal.TitleSecondary center>
                    {t('CHANGE_COUNTRY')}
                </Modal.TitleSecondary>
                <Modal.Description>
                    {t('SETTINGS_CHANGE_COMPANY_TEXT')}:
                </Modal.Description>
            </Modal.Content>
            <Modal.Footer>
                <Modal.ButtonsWrapper>
                    <Button
                        onClick={onClose}
                        testId="button_cancel"
                        variant={'secondary'}
                    >
                        {t('CANCEL')}
                    </Button>
                    <Button
                        onClick={() => {
                            onClose();
                            void AuthService.logout(true);
                        }}
                        testId="button_logout"
                        variant={'primary'}
                    >
                        {t('LOGOUT')}
                    </Button>
                </Modal.ButtonsWrapper>
            </Modal.Footer>
        </ModalComponent>
    );
};
